import React, { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  Button,
} from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Form } from "../../../components/form";
import { Splitter } from "@progress/kendo-react-layout";
import { ImportDatasetPageForm } from "./importdatasetpageform";
import { NavLink } from "react-router-dom";
import { ReactComponent as ImportIcon } from "../../../icons/import.svg";
import {
  canCreateDataset,
  canCreateReports, 
} from "../../../routing/authorizationhandlers";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, onToolsToggle, onClose, t } =
    props;

  const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
  const toolsVisibleTitle = pageState.toolsVisible
    ? t("datasets.importdataset.hide")
    : t("datasets.importdataset.show");

  return (
    <Toolbar className="dataset-toolbar">
      {currentUser.IsAuthenticated && canCreateReports(currentUser) && (
        <Fragment>
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon={toolsVisibleIcon}
              onClick={props.onToolsToggle}
            >
              {toolsVisibleTitle}
            </Button>
          </ToolbarItem>
          <ToolbarSeparator />
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon="close"
              onClick={onClose}
            >
              {t("datasets.importdataset.close")}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}
    </Toolbar>
  );
};

export const ImportDatasetPageBody = (props) => {
  const {
    onNew,
    onSave,
    onClose,
    onDelete,
    onErrorbarClose,
    updateDirtyState,
    onSplitterChange,
    onToolsToggle,
    ...other
  } = props;
  const { t } = useTranslation();

  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const appearance = useSelector((state) => state.appearance);
  const pageState = useSelector((state) => state.importDatasetPage);

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Splitter
          style={{ border: "none" }}
          panes={pageState.panes}
          onChange={onSplitterChange}
        >
          <div className="datasets-page-manager">
            {canCreateDataset(currentUser) && (
              <div className="new-dataset">
                <NavLink to="/createdataset">
                  <div className="new-container" style={{}}>
                    <div>
                      <div className="k-icon k-i-plus"></div>
                      <div>{t("datasets.importdataset.newdataset")}</div>
                    </div>
                  </div>
                </NavLink>
                <NavLink onClick={onNew}>
                  <div className="new-container" style={{}}>
                    <div>
                      <ImportIcon width={15} />
                      <div>{t("datasets.importdataset.import1")}</div>
                    </div>
                  </div>
                </NavLink>
              </div>
            )}
          </div>
          <div className="datasets-page-wrapper">
            <Form
              className="datasets-page-form"
              currentTheme={currentTheme}
              currentUser={currentUser}
              toolbarRenderer={toolbarRenderer}
              t={t}
              onNew={onNew}
              onSave={onSave}
              onClose={onClose}
              onDelete={onDelete}
              errorMessages={pageState.formServerErrors}
              onErrorbarClose={onErrorbarClose}
              onToolsToggle={onToolsToggle}
              pageState={pageState}
            >
              {pageState.mode > 0 ? (
                <ImportDatasetPageForm updateDirtyState={updateDirtyState} />
              ) : (
                <Fragment></Fragment>
              )}
            </Form>
          </div>
        </Splitter>
      )}
      <style>
        {`                  
                .datasets-page > .content
                {
                    
                }

                  .datasets-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .datasets-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                   
                  .datasets-page .datasets-page-wrapper{
                    border: ${currentTheme.pageFormBorder};   
                    height:100%;  direction:${
                      appearance.isRightToLeft ? "rtl" : "ltr"
                    } 
                    } 

                    .datasets-page .datasets-page-wrapper .k-upload{
                     
                      direction:${appearance.isRightToLeft ? "ltr" : "ltr"} 
                    }
 

                .datasets-page > .content .datasets-page-manager
                {
                    border: ${currentTheme.managerBorder};
                    border-radius: ${currentTheme.pageBorderRadius};
                    background-color: ${currentTheme.componentBgFaded};
                    height:100%;
                }
                
                .datasets-page > .content .datasets-page-manager .k-dropdownlist
                {
                    /*bg of datasets dropdown*/
                    background-color: transparent;
                    color: ${currentTheme.componentText};
                }

                /*.datasets-page .content .datasets-page-manager .k-dropdownlist:focus
                {
                    box-shadow: none;   
                }*/

                .datasets-page > .content .datasets-page-manager .panel-datasets .k-input::placeholder
                {
                    color: ${currentTheme.componentText};
                    /*font-style: italic;*/
                }

                .datasets-page > .content .datasets-page-manager .k-panelbar
                {
                    /*required*/
                    background-color: transparent;
                }

                .datasets-page > .content .datasets-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                {
                    /*the arrow near every panel header*/
                    color: ${currentTheme.touchColor}!important;
                    margin-right: 6px;
                }

                .datasets-page > .content .datasets-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                {
                    /*the span in the above <li> i.e. the title of every group in the manager: datasets, datasets, columns and description*/  
                    background-color: transparent;
                    color: ${currentTheme.touchColor};
                    border-bottom: 1px solid ${currentTheme.separatorColor}; 
                }

                .datasets-page > .content .datasets-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                {
                    /*the above hovered - do nothing*/
                }

                .datasets-page > .content .datasets-page-manager .datasets .list-item:hover
                {
                    /*expression item hover */
                    background-color: ${currentTheme.componentBorderColor};
                    cursor: pointer;
                }

                .datasets-page > .content .datasets-page-manager .dataset,
                .datasets-page > .content .datasets-page-manager .description,
                .datasets-page > .content .datasets-page-manager .k-child-animation-container
                {
                    /*bg color of exp. manager elements */
                }

                .datasets-page > .content .datasets-page-manager .list-container
                {
                    /*bg of both the exp. and columns Lists*/
                    background-color: transparent;
                    padding : 0;/*can add padding to list items*/
                }

                .datasets-page > .content .datasets-page-manager .k-panelbar-header
                {
                    background-color: transparent;
                }

                .datasets-page > .content .datasets-page-manager .k-panelbar-content
                {
                    background-color: transparent;
                }

                .datasets-page > .content .datasets-page-manager .datasets .list-item-data-type-icon
                {
                    /*first icon in datasets list*/
                    padding-left: 12px
                }

                .datasets-page > .content .datasets-page-manager .datasets .list-item-expression-icon
                {
                    /*second icon in datasets list*/
                    padding: 5px 3px;                 
                }

                .datasets-page > .content .datasets-page-manager .datasets .list-item-title
                {
                    vertical-align: middle;/*fine tuning*/
                }

                .datasets-page > .content .datasets-page-manager .columns
                {
                    /*space above the first column in the list*/
                    padding-top: 6px;
                }

                .datasets-page > .content .datasets-page-manager .columns .list-item-data-type-icon
                {
                    /*first icon in columns list*/
                    padding-left: 12px;
                }

                .datasets-page > .content .datasets-page-manager .columns .list-item-title
                {
                }                    

                /*the form*/
                .datasets-page-form   
                {
                    background-color: transparent;
                    padding-left: 0px;
                    border: ${currentTheme.pageFormBorder};   
                    border-radius: ${currentTheme.pageBorderRadius};
                }

                /*form toolbar*/
                .datasets-page-form > .toolbar .k-toolbar
                {
                    width: 100%;
                    border-left: none !important;
                    border-bottom: 1px solid ${currentTheme.separatorColor};
                    border-top: none !important;
                    border-right: none !important;
                    background-color: ${currentTheme.toolbarBg};/*transparent;*/
                }

                .datasets-page > .content .toolbar .k-button
                {
                    /*the toolbar buttons*/
                    border: none;
                    padding: 6px 8px;
                }

                .datasets-page > .content .toolbar .k-button-text
                {
                    /*color of the text in every toolbar button=black in azure theme*/
                    color: ${currentTheme.toolbarText};
                }

                .datasets-page > .content .toolbar .k-button-icon
                {
                    font-weight: 500;
                    color: ${currentTheme.primary};
                }

                .datasets-page > .content .form-root .k-form .k-form-field:nth-child(1)
                {
                    margin-top: 4px;
                }

                .datasets-page > .content .form-root .k-form .k-form-field
                {
                    margin-top: 32px;
                }

                // .datasets-page > .content .form-root .k-form .k-form-field:nth-child(6)                   
                // {
                //     margin-top: -4px !important;
                //     width: 100%;
                // }

                .datasets-page > .content .form-root .content
                {
                    background-color: ${currentTheme.pageContentBg};
                }

                /*styling the popup menu */
                .k-popup ul{
                    padding: 0px;
                }

                .k-popup ul > li{
                    margin: 0;
                    padding: 0px;                                
                }

                .k-popup ul > li > span{
                    border: none !important;
                    box-shadow: none !important;
                }

                .k-menu-link{
                    padding: 0px 0px !important;
                    
                }


                    /*new dataset*/
                    .datasets-page .new-dataset 
                    {
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        align-items: center;
                        padding: 32px 16px;

                    }

                    .datasets-page .new-dataset a
                    {
                        width: 100%;
                        display: inline-block;
                        color: ${currentTheme.componentText};
                        text-decoration: none;
                        margin-bottom:15px;
                    }

                    .datasets-page .new-dataset .new-container
                    {
                        padding: 16px 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid ${currentTheme.separatorColor};
                        border-radius: 8px;
                        color: ${currentTheme.componentText};   
                        opacity: 0.5;
                    }
                    
                    .datasets-page .new-dataset .new-container:hover
                    {
                        cursor: pointer;
                        background-color: ${currentTheme.componentBgFaded};
                        border-color: ${currentTheme.separatorColor};
                        opacity: 1;
                        transition: opacity 1000ms;
                    }

                    .datasets-page .new-dataset .new-container > div
                    {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }                    

                    .datasets-page .new-dataset .new-container .k-icon
                    {
                        color: ${currentTheme.componentText};   
                        font-size: 20px;
                        font-weight: 300;
                        margin-right: ${appearance.isRightToLeft ? "0" : "4px"};
                        margin-left: ${appearance.isRightToLeft ? "4px" : "0"};
                    }    
                    
                    .datasets-page .new-dataset .new-container svg
                    {
                        color: ${currentTheme.componentText};   
                        margin-right: 4px;
                    }                                   

                `}
      </style>
    </Fragment>
  );
};
